import { render, staticRenderFns } from "./AddGroupNumber2022.vue?vue&type=template&id=73cedc97&scoped=true"
import script from "./AddGroupNumber2022.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber2022.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber2022.vue?vue&type=style&index=0&id=73cedc97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cedc97",
  null
  
)

export default component.exports